<template>
  <div class="p20">
    <h2>角色管理</h2>
  </div>
</template>

<script>
export default {
  name: 'RoleManagement',
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>

</style>